export const COMPANY_NAME = "Seren Body LLC";
export const COMPANY_SHORT = "Seren Body";
export const COMPANY_INITIALS = "SB";
export const COMPANY_ADDRESS_FULL = "7491 Center Ave, Huntington Beach, CA 92647-9150";
export const COMPANY_LOCATION = "Huntington Beach, CA";
export const COMPANY_REGION = "Orange County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=7491%20Center%20Ave%2C%20Huntington%20Beach%2C%20CA%2092647-9150";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory" },
  { "label": "Region", "value": "Orange County" },
  { "label": "Location", "value": "Huntington Beach, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Seren Body LLC" },
  { "label": "City / State", "value": "Huntington Beach, CA" },
  { "label": "Address", "value": "7491 Center Ave, Huntington Beach, CA 92647-9150" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Clear details", "body": "A concise public profile built around the organization name and address." },
  { "icon": "✦", "title": "Local reference", "body": "A simple place to find Seren Body in Huntington Beach." },
  { "icon": "✿", "title": "Thoughtful presentation", "body": "An editorial layout with generous spacing and accessible navigation." },
  { "icon": "❍", "title": "Visit information", "body": "Use the listed address for public correspondence and directory listings." },
];
